import { render, staticRenderFns } from "./ArticleSelectLangNovotelTemplate.vue?vue&type=template&id=f0c90b2a&scoped=true"
import script from "./ArticleSelectLangNovotelTemplate.vue?vue&type=script&lang=js"
export * from "./ArticleSelectLangNovotelTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c90b2a",
  null
  
)

export default component.exports